import { Stack } from "@mui/material";
import { IconCloseCircle } from "src/components/icons-mui/close-circle";
import { Button } from "src/components-mui/base/button/button";
import { toSxArray } from "src/utils/mui/sx/sx";
import type { ISelectablePickerItem, ISelectionPickerChipsProps } from "./selection-picker.types";

export function SelectionPickerChips<TItem extends ISelectablePickerItem>({
    picker,
    items,
    getLabel,
    disabled,
    ...stackProps
}: Readonly<ISelectionPickerChipsProps<TItem>>) {
    return (
        <Stack
            direction="row"
            {...stackProps}
            sx={[
                {
                    gap: 1,
                    flexWrap: "wrap",
                },
                ...toSxArray(stackProps.sx),
            ]}
        >
            {items.map(item => {
                const isActive = picker.isSelected(item);
                return (
                    <Button
                        key={item.id}
                        onClick={() => picker.toggle(item)}
                        disabled={Boolean(disabled) || (picker.isFull && !isActive)}
                        variant="outlined"
                        color="gray"
                        aria-pressed={isActive}
                        sx={{
                            height: theme => theme.spacing(4),
                            py: "5.5px",
                            fontSize: "sm",
                            px: 2,
                            "&:focus": { backgroundColor: "gray.100" },
                            ...(isActive && {
                                backgroundColor: "green.100",
                                "&:hover": { backgroundColor: "green.100" },
                                "&:focus": { backgroundColor: "green.100" },
                            }),
                            "&:active": { backgroundColor: "green.100" },
                            "&.Mui-disabled": { cursor: "not-allowed", pointerEvents: "auto" },
                            "&.Mui-disabled:hover": { backgroundColor: isActive ? "green.100" : "transparent" },
                        }}
                        endIcon={isActive ? <IconCloseCircle sx={{ height: "16px" }} /> : undefined}
                    >
                        {getLabel(item)}
                    </Button>
                );
            })}
        </Stack>
    );
}
